import { Box, Typography } from '@mui/material'
import React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


export default function FeatureCard({title , desc}) {
  return (
    <Box
        sx={{
          border: "1px solid #d6f7ed",
          borderRadius: "15px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          p: 2,
        }}
      > <Box sx={{display : "flex", gap : "15px"}}>
        <CheckCircleIcon  color="success" sx={{fontSize:{xs: "22px", sm: "24px", md: "28px" }}}/>
        <Typography fontWeight={500} sx={{fontSize:{xs: "13px", sm: "15x", md: "18px" }}}  >
          {/* AI-Powered Risk Anticipation */} {title}
        </Typography>
      </Box>
        
        <Typography sx={{ fontSize: "12px" }}>
          {/* Uses advanced AI analytics to identify stocks showing early signs
          of technical or fundamental weakness. */}
          {desc}
        </Typography>
      </Box>
  )
}
